/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 09:48:19
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-19 09:54:05
 */

const state = {
  // ------------|当前用户:自身状态|------------
  currentUserStatus: {
    isLogin: false, // 是否登陆
    isHaveGroup: null, // 是否拥有社群，默认空白
    // code:'' // 用户登录凭证（有效期五分钟）
    // isAuthenticated: null // 是否通过身份验证
    // openId:'' // 微信openID
  },
  currentUserInfo:{}, // 当前用户信息

  // ------------|当前用户:社群信息|------------
  currentGroupId: null, // 当前社群id
  currentGroupInfo: {}, // 当前社群的详情


  groupOfCurrentUser:{},
  // ------------|首页信息|------------
  homeInfo: {},

  settingInfo: null,
  setWechatImg: '',
  usersPool: {
  },
  followersIds: {},
  followingsIds: {},
  groups: {
    /** 仅加入的圈子 */
    member: {
      list: [],
      canLoad: true,
      loaded: false
    },
    guest: {
      list: [],
      canLoad: true,
      loaded: false
    },
    manager: {
      list: [],
      canLoad: true,
      loaded: false
    },
    creator: {
      list: [],
      canLoad: true,
      loaded: false
    }
  },
  groupList: {}, // 我的社群列表
  visitedList: {}, // 浏览的社群列表
}

const mutations = {
  // 修改登录状态
  setUserIsLogin: (state, data) => {
    state.currentUserStatus.isLogin = data
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
